import { useSuspenseQuery } from "@apollo/client";
import {
    BusinessCode,
    LightMeDocument,
    LightMeQuery,
    LightMeQueryVariables,
} from "generated/graphql";

export const useLightMe = () => {
    const { data, error } = useSuspenseQuery<
        LightMeQuery,
        LightMeQueryVariables
    >(LightMeDocument, {
        variables: {
            businessCode: (process.env.NEXT_PUBLIC_BUSINESS_CODE ||
                BusinessCode.Ub) as BusinessCode,
            language: process.env.NEXT_PUBLIC_STORYBLOK_LANGUAGE ?? "",
        },
    });
    if (data.me?.__typename !== "Customer") {
        return {
            customer: null,
            error,
        };
    }

    return {
        customer: data.me,
        error,
    };
};
